export default __webpack_public_path__ + "static/media/right_bg.c51391e3.png";